import type { GridAlignment } from "@mui/x-data-grid-premium";
import { getRowGroupingFieldFromGroupingCriteria } from "@mui/x-data-grid-premium";
import type {
  ColumnHorizontalAlignment,
  FieldConfiguration,
} from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { GroupingField } from "../../../../../../../../api/types/svTypes.ts";

type ColumnAlignmentField = Pick<FieldConfiguration, "guid" | "customizations">;

const gridAlignments: Record<ColumnHorizontalAlignment, GridAlignment> = {
  Left: "left",
  Center: "center",
  Right: "right",
};

const columnAlignments: Record<GridAlignment, ColumnHorizontalAlignment> = {
  left: "Left",
  center: "Center",
  right: "Right",
};

export const toGridAlignment = (alignment: ColumnHorizontalAlignment): GridAlignment => gridAlignments[alignment];

export const fromGridAlignment = (align: GridAlignment): ColumnHorizontalAlignment => columnAlignments[align];

export const getTabularColumnAlignments = (
  fields: readonly ColumnAlignmentField[],
  groups: readonly GroupingField[]
): ReadonlyMap<string, GridAlignment> => {
  const alignments = new Map<string, GridAlignment>();
  for (const { guid, customizations } of fields) {
    const alignment = customizations?.horizontalAlignment;
    if (alignment) {
      alignments.set(guid, toGridAlignment(alignment));
    }
  }
  for (const group of groups) {
    const alignment = group.customizations?.horizontalAlignment;
    if (alignment) {
      alignments.set(getRowGroupingFieldFromGroupingCriteria(group.id), toGridAlignment(alignment));
    }
  }
  const combined = groups[0]?.customizations?.horizontalAlignment;
  if (combined) {
    alignments.set(getRowGroupingFieldFromGroupingCriteria(null), toGridAlignment(combined));
  }
  return alignments;
};
